import instance from "./instance";

let isSaving = false;
let pendingBatch = null;

const abandonedCartIsEnabled = (state) => {
  const settings = state.store?.store?.settings || {};
  return (
    settings.enable_abandoned_carts ||
    (settings.enable_sharing_carts_staff && settings.enable_sharing_carts)
  );
};

const performSave = async ({ dispatch, payload }) => {
  try {
    const response = await instance.post("/save_abandoned_cart/", payload);
    if (response.data.success) {
      dispatch({ type: "SET_ABANDONED_CART", payload: response.data.id });
    }
    return response;
  } catch (error) {
    // Abandoned-cart persistence must not block cart or checkout interactions.
    return null;
  }
};

const drainSaveQueue = async (firstBatch) => {
  let batch = firstBatch;

  while (batch) {
    const response = await performSave(batch.job);
    batch.resolve.forEach((resolve) => resolve(response));
    batch = pendingBatch;
    pendingBatch = null;
  }

  isSaving = false;
};

export const saveLatestAbandonedCart = (
  dispatch,
  getState,
  { requireCartItems = false } = {},
) => {
  const state = getState();
  if (!abandonedCartIsEnabled(state)) return Promise.resolve(null);
  if (requireCartItems && !state.cart?.cart?.length)
    return Promise.resolve(null);

  const job = {
    dispatch,
    payload: {
      cart: state.cart,
      customers: state.customers,
      branch: state.branch,
      language: state.store.language,
    },
  };

  return new Promise((resolve) => {
    if (isSaving) {
      if (pendingBatch === null) pendingBatch = { job, resolve: [] };
      pendingBatch.job = job;
      pendingBatch.resolve.push(resolve);
      return;
    }

    isSaving = true;
    drainSaveQueue({ job, resolve: [resolve] });
  });
};
